
angular.module('qkr.refund').config(($routeSegmentProvider, appUrl) => {
    $routeSegmentProvider.options.autoLoadTemplates = true;

    $routeSegmentProvider.
        when('/refunds', 'refunds', {pageTitle: "Refunds"});

    $routeSegmentProvider.
        segment('refunds', {
            controller: 'refundController',
            template: require('../../refund/templates/refunds.html'),
            resolve: {
                refundListInitData(transService) {
                    'ngInject';
                    return transService.resolveRefundTransList({
                            allTransactions: false,
                            startDate: new Date().getTime(),
                            endDate: new Date().getTime(),
                            ourRef: null,
                            firstName: null,
                            lastName: null
                        });
                }
            }
        });
});



// WEBPACK FOOTER //
// ./src/refund/config/refund.config.js